import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-invoice-emails-errors',
  templateUrl: './invoice-emails-errors.component.html',
  styleUrls: ['./invoice-emails-errors.component.scss']
})
export class InvoiceEmailsErrorsComponent implements OnInit {

  messages: string[];
  constructor(
    public dialog: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.messages = this.config.data.messages;
  }

  ngOnInit(): void {
  }

}
